import './Icon_Chevron_Left.css';
 
function Icon_Chevron_Left() {
  return (
<div className='icon-container-chevron-left'>
<svg viewBox="0 0 20 20" className="chevron-left-svg">
<path d="m13 16-6-6 6-6" />
</svg>
</div>
  );
}
 
export default Icon_Chevron_Left;